import { CalendarIcon, EditIcon } from '@wonderschool/common-base-ui';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { BillingIntervalEnum } from '../../enums';

type InvoicePreviewCardProps = {
  isProrated: boolean;
  label: string;
  serviceStart?: Date;
  serviceEnd?: Date;
  amount: number;
  dueDate: Date;
  billingInterval?: BillingIntervalEnum;
  onEdit?: () => void;
};

const InvoicePreviewCard = ({
  isProrated,
  label,
  serviceStart,
  serviceEnd,
  amount,
  dueDate,
  billingInterval,
  onEdit,
}: InvoicePreviewCardProps) => {
  const { t } = useTranslation();
  const isFutureInvoice = serviceStart && serviceEnd;

  const formatHeader = () => {
    if (isFutureInvoice) {
      return `${t(label.toLocaleLowerCase())} ${t('enrollments.invoicePreview.invoiceLabel').toLocaleLowerCase()} ${isProrated ? t('enrollments.prorated') : ''}`;
    }
    return t(label);
  };
  return (
    <div className="flex flex-col rounded-lg border-2 border-gray-300 p-4">
      <div className="flex items-start justify-between border-b border-gray-300 pb-4">
        <div className="flex flex-col gap-1">
          <div className="text-sm font-bold text-gray-900">{formatHeader()}</div>
          {isFutureInvoice && (
            <div className="text-xs text-gray-800">
              {billingInterval === BillingIntervalEnum.WEEKLY
                ? t('enrollments.weekOf', { week: dayjs(serviceStart).format('MMMM D') })
                : `${dayjs(serviceStart).format('MMMM D')} - ${dayjs(serviceEnd).format('MMMM D, YYYY')}`}
            </div>
          )}
        </div>
        {onEdit && (
          <div className="ml-2 inline cursor-pointer text-sm text-blue-900" onClick={onEdit}>
            <span>
              <EditIcon className="size-4" />
            </span>{' '}
            {t('common.edit')}
          </div>
        )}
      </div>
      <div className="flex items-center justify-between pt-4">
        <div className="flex text-base font-bold">
          <div>{t('enrollments.invoicePreview.totalLabel')}:&nbsp;</div>
          <div>${(amount || 0).toFixed(2)}</div>
        </div>
        <div className="flex items-center gap-1 rounded-3xl bg-purple-200 p-2 text-xs text-gray-900">
          <CalendarIcon className="h-4 w-4 text-purple-900" />
          <div>
            {t('enrollments.due')} {dayjs(dueDate).format('MMMM D')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreviewCard;
